module.exports = __webpack_public_path__ + "static/media/img-placeholder.af1be4da.png";